import React, { useEffect, useRef, useState } from 'react';
import { HelpCircleIcon, MinusIcon, PlusIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Necesito experiencia?',
  a: 'No. La colección está diseñada para quienes comienzan desde cero.'
}, {
  q: '¿El contenido es digital?',
  a: 'Sí. Recibirás todos los materiales en formato PDF.'
}, {
  q: '¿Cuándo accedo?',
  a: 'Inmediatamente después de completar la compra.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. También funciona en tablet y computadora.'
}, {
  q: '¿Necesito conexión a internet?',
  a: 'Solo para descargar los archivos. Luego podrás consultarlos cuando quieras.'
}, {
  q: '¿El acceso vence?',
  a: 'No. El acceso es de por vida.'
}];
type Faq = (typeof FAQS)[number];
type AccordionItemProps = {
  faq: Faq;
  isOpen: boolean;
  onToggle: () => void;
};
function AccordionItem({
  faq,
  isOpen,
  onToggle
}: AccordionItemProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => setHeight(isOpen ? contentRef.current?.scrollHeight ?? 0 : 0), [isOpen]);
  return <div className={`overflow-hidden rounded-2xl border bg-[#101914] transition-colors ${isOpen ? 'border-[#e6a45c]/60' : 'border-white/10'}`} data-id="element-100" data-mp="1rp7f1wy3pr1u">
      <button type="button" onClick={onToggle} className="flex w-full items-center justify-between gap-4 p-5 text-left" aria-expanded={isOpen} data-id="element-101" data-mp="25hniuzyttt3t">
        <span className={`text-lg font-bold ${isOpen ? 'text-[#e6a45c]' : 'text-stone-100'}`} data-id="element-102" data-mp="2fcz0pr5j7gfs">{faq.q}</span>
        <span className="shrink-0 text-[#e6a45c]" data-id="element-103" data-mp="2adm5ai0lh11l">{isOpen ? <MinusIcon className="h-5 w-5" data-id="element-104" data-mp="2ah05pkpp706e" /> : <PlusIcon className="h-5 w-5" data-id="element-105" data-mp="2oeotb0b5glf5" />}</span>
      </button>
      <div ref={contentRef} style={{
      maxHeight: height
    }} className="overflow-hidden transition-all duration-300" data-id="element-106" data-mp="2oc2kkxcivzvc"><p className="border-t border-white/5 bg-[#17231c] px-5 pb-5 pt-4 leading-relaxed text-stone-300" data-id="element-107" data-mp="u0ficprawx4x">{faq.a}</p></div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [ref, visible] = useReveal();
  return <section className="border-t border-white/5 bg-[#101914] px-4 py-14 md:py-20" data-id="element-108" data-mp="2p5on24p7o0xt">
      <div className="container mx-auto max-w-5xl" data-id="element-109" data-mp="2u36ufqnky83p">
        <div className="mb-10 text-center" data-id="element-110" data-mp="2z18gmkgaynje"><HelpCircleIcon className="mx-auto mb-4 h-8 w-8 text-[#e6a45c]" data-id="element-111" data-mp="2z0yq8vrcied6" /><h2 className="font-serif text-3xl font-bold text-white md:text-5xl" data-id="element-112" data-mp="333v09y2tl25i">Preguntas Frecuentes</h2></div>
        <div ref={ref} className={`reveal grid items-start gap-4 md:grid-cols-2 ${visible ? 'is-visible' : ''}`} data-id="element-113" data-mp="3837ytg31zxnx">
          {FAQS.map((faq, index) => <AccordionItem key={faq.q} faq={faq} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-114" data-mp="3czomyaa96c10" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}